import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedStateService {
  private submittedWithoutPaymentSubject = new BehaviorSubject<boolean>(false);
  submittedWithoutPayment$ = this.submittedWithoutPaymentSubject.asObservable();

  private postSubmissionSubject = new BehaviorSubject<boolean>(false);
  submittedWithPayment$ = this.postSubmissionSubject.asObservable();

  setSubmittedWithoutPayment(value: boolean) {
    this.submittedWithoutPaymentSubject.next(value);
  }

  setPostSubmission(value: boolean) {
    this.postSubmissionSubject.next(value);
  }
}
